"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_design_system_1 = require("@hdh-core/react-design-system");
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const react_redux_1 = require("react-redux");
const transactionSigningSelector_1 = require("@/features/transaction-signing/selectors/transactionSigningSelector");
const transactionSigningAction_1 = require("@/features/transaction-signing/actions/transactionSigningAction");
const constants_1 = require("@/features/transaction-signing/constants");
const transactionFeatureUtils_1 = require("./transactionFeatureUtils");
require("./HardToken.css");
const HardTokenStep2_1 = require("./HardTokenStep2");
const HardTokenStep3_1 = require("./HardTokenStep3");
const HardTokenStep4_1 = require("./HardTokenStep4");
function HardTokenApproveTransaction({ onClose }) {
    const [error, setError] = (0, react_1.useState)(undefined);
    const intl = (0, react_intl_1.useIntl)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { authRequestDetail, hardTokenOTP, showTransactionSigningHardTokenOTP, errorMsg, loading, exceedMaxAttempt } = (0, react_redux_1.useSelector)(transactionSigningSelector_1.transactionSigningSelector);
    const ifNotExceedMaxAttempt = fun => (...args) => {
        if (exceedMaxAttempt) {
            dispatch((0, transactionSigningAction_1.setMaxAttemptExceeded)(false));
            dispatch((0, transactionSigningAction_1.toggleCloseHardTokenOtp)());
            dispatch((0, transactionSigningAction_1.showExceedMaximumRetry)());
        }
        else {
            fun(...args);
        }
    };
    if (errorMsg) {
        setError(errorMsg);
        dispatch((0, transactionSigningAction_1.setErrorMsg)(undefined));
    }
    const handleOtpInputChange = ifNotExceedMaxAttempt((event) => {
        setError(undefined);
        const { value } = event.target;
        dispatch((0, transactionSigningAction_1.setHardTokenOtpCode)(value));
    });
    const handleToggleSubmitOTP = ifNotExceedMaxAttempt(() => {
        if (hardTokenOTP && hardTokenOTP.length === 8) {
            setError(undefined);
            dispatch((0, transactionSigningAction_1.toggleSubmitHardWareToken)());
        }
        else {
            setError(constants_1.SYSTEM_MESSAGE_HARD_TOKEN.INVALID_RESPONSE_CODE);
        }
        dispatch((0, transactionSigningAction_1.setHardTokenOtpCode)(''));
    });
    const onCloseClick = ifNotExceedMaxAttempt(() => {
        onClose();
        dispatch((0, transactionSigningAction_1.setHardTokenOtpCode)(''));
        dispatch((0, transactionSigningAction_1.toggleCloseHardTokenOtp)());
    });
    return (react_1.default.createElement(react_design_system_1.Dialog, { open: showTransactionSigningHardTokenOTP, width: "590px" },
        react_1.default.createElement(react_design_system_1.LoadingSpinner, { visible: loading }),
        react_1.default.createElement(react_design_system_1.Dialog.Title, { onClose: onCloseClick }, intl.formatMessage({ id: 'transaction-signing-title' })),
        react_1.default.createElement(react_design_system_1.Dialog.Body, null,
            (0, transactionFeatureUtils_1.step1Box)(),
            (0, HardTokenStep2_1.step2Box)(),
            (0, HardTokenStep3_1.step3Box)(authRequestDetail),
            (0, HardTokenStep4_1.step4Box)(authRequestDetail),
            react_1.default.createElement(react_design_system_1.Box, { mb: "md" },
                react_1.default.createElement(react_design_system_1.Card, { shadow: "none", padding: "0", className: "rds-bg-pearl", borderRadius: "md" },
                    react_1.default.createElement(react_design_system_1.Row, null,
                        react_1.default.createElement(react_design_system_1.Col, { size: 8, className: "rds-pr-sm rds-pl-xl rds-pt-xl rds-pb-xl" },
                            react_1.default.createElement(react_design_system_1.Text, { size: "sm", bold: true, component: "div" }, intl.formatMessage({ id: 'transaction-signing-step-5' })),
                            react_1.default.createElement(react_design_system_1.Text, { size: "xs", component: "div", className: "rds-mt-xs" }, intl.formatMessage({ id: 'transaction-signing-hard-token-step-5-msg' })),
                            react_1.default.createElement(react_design_system_1.Col, { size: 9, className: "rds-mt-xs" },
                                react_1.default.createElement(react_design_system_1.Input, { maxLength: 8, id: "hardTokenApproveInput", formatType: "numeric", type: 'password', label: "", placeholder: intl.formatMessage({ id: 'transaction-signing-hard-token-placeholder' }), onChange: handleOtpInputChange, value: hardTokenOTP, isWhiteBg: true, error: error
                                        ? intl.formatMessage({ id: error.msgId }, { digit: '8' }) || intl.formatMessage({ id: error.defaultMsg }, { digit: '8' })
                                        : undefined }))),
                        react_1.default.createElement(react_design_system_1.Col, { size: 4, justifyContent: "end", className: "rds-pr-xs rds-pl-md rds-pt-4xl rds-pb-xl" },
                            react_1.default.createElement(react_design_system_1.Image, { type: "approve_trasaction_web_step_7", width: "130", id: '' }))))),
            react_1.default.createElement(react_design_system_1.Row, { className: "rds-pb-xl rds-pt-xs" },
                react_1.default.createElement(react_design_system_1.Col, { size: 8 }),
                react_1.default.createElement(react_design_system_1.Col, { size: 4, className: "rds-pl-xl" },
                    react_1.default.createElement(react_design_system_1.Button, { id: "submitBtn", disabled: hardTokenOTP.length < 8, onClick: handleToggleSubmitOTP }, intl.formatMessage({ id: 'transaction-signing-hard-token-submit' })))))));
}
exports.default = HardTokenApproveTransaction;
